import React, { useState } from "react";
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";

interface PaymentFormProps {
  clientSecret: string;
  onSuccess: () => void;
  onBack: () => void;
}

const PaymentForm: React.FC<PaymentFormProps> = ({ clientSecret, onSuccess, onBack }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      const { error: submitError } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/order-confirmation`,
        },
        redirect: "if_required",
      });

      if (submitError) {
        setError(submitError.message || "An error occurred during payment");
        setLoading(false);
      } else {
        // Payment successful
        onSuccess();
      }
    } catch (err) {
      console.error("Payment error:", err);
      setError("An unexpected error occurred. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div style={{
      backgroundColor: "#f9f9f9",
      padding: "30px",
      borderRadius: "8px",
    }}>
      <h3 style={{ marginBottom: "20px", fontSize: "20px" }}>Payment Details</h3>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "20px" }}>
          <PaymentElement />
        </div>

        {error && (
          <div style={{
            backgroundColor: "#f8d7da",
            color: "#721c24",
            padding: "15px",
            borderRadius: "4px",
            marginBottom: "20px",
            fontSize: "14px",
          }}>
            {error}
          </div>
        )}

        <div style={{ display: "flex", gap: "15px" }}>
          <button
            type="button"
            onClick={onBack}
            disabled={loading}
            className="butn border rounded-pill"
            style={{
              flex: 1,
              padding: "15px",
              fontSize: "16px",
              fontWeight: "600",
              opacity: loading ? 0.6 : 1,
              cursor: loading ? "not-allowed" : "pointer",
              color: "#333",
            }}
          >
            <span>Back</span>
          </button>

          <button
            type="submit"
            disabled={!stripe || loading}
            className="butn border rounded-pill hover-bg-black bg-orange1 text-white"
            style={{
              flex: 2,
              padding: "15px",
              fontSize: "16px",
              fontWeight: "600",
              opacity: !stripe || loading ? 0.6 : 1,
              cursor: !stripe || loading ? "not-allowed" : "pointer",
            }}
          >
            <span>{loading ? "Processing..." : "Pay Now"}</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default PaymentForm;
